import { BaseEditItemStore } from "@leap4/frontend";
import { IPublisherLogins} from "../../interfaces/IPublisherLogins";

export class EditPublisherLoginsStore extends BaseEditItemStore<IPublisherLogins>{
    entityName: string = "Publisher Login";
}